/* eslint-disable */
// prettier-ignore
import * as Types from '../../../../../../graphql/__generated__';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SideBar_OfferingDetails_Offering_ManagerResponsibilitiesFullPartsFragment = {
  readonly __typename?: 'ManagerResponsibilitiesFull';
  readonly stabilizationAgent?: string | null;
  readonly settlementAgent?: string | null;
  readonly logisticsAgent?: string | null;
  readonly leftLead?: string | null;
};

export type SideBar_OfferingDetails_Offering_ManagerFullPartsFragment = {
  readonly __typename?: 'ManagerFull';
  readonly id: string;
  readonly cmgEntityKey: string;
  readonly role: Types.ManagerRole;
  readonly isJuniorRole?: boolean | null;
  readonly isParticipating: boolean;
  readonly firmName: string;
};

export type SideBar_OfferingDetails_Offering_FilingFullPartsFragment = {
  readonly __typename?: 'FilingFull';
  readonly id: string;
  readonly filingType: Types.FilingType;
  readonly ipoRangeLow?: number | null;
  readonly ipoRangeHigh?: number | null;
  readonly offerPrice?: number | null;
  readonly coupon?: number | null;
  readonly couponTalkHigh?: number | null;
  readonly couponTalkLow?: number | null;
  readonly premium?: number | null;
  readonly premiumTalkHigh?: number | null;
  readonly premiumTalkLow?: number | null;
};

export type SideBar_OfferingDetails_Offering_FollowOnPricingFullPartsFragment = {
  readonly __typename?: 'FollowOnPricingFull';
  readonly reOfferLow?: number | null;
  readonly reOfferHigh?: number | null;
  readonly lastTradeBeforeLaunch?: number | null;
};

export type SideBar_OfferingDetails_OfferingPartsFragment = {
  readonly __typename?: 'OfferingFull';
  readonly id: string;
  readonly type: Types.OfferingType;
  readonly status: Types.OfferingStatus;
  readonly pricingInstrumentId?: string | null;
  readonly isExecutingOnPlatform: boolean;
  readonly pricingCurrencyCode: string;
  readonly priceRangeLow?: number | null;
  readonly priceRangeHigh?: number | null;
  readonly pricingInstrumentStockSymbol?: string | null;
  readonly sizeInCurrency?: number | null;
  readonly syndicate?: {
    readonly __typename?: 'SyndicateFull';
    readonly managers: ReadonlyArray<{
      readonly __typename?: 'ManagerFull';
      readonly id: string;
      readonly cmgEntityKey: string;
      readonly role: Types.ManagerRole;
      readonly isJuniorRole?: boolean | null;
      readonly isParticipating: boolean;
      readonly firmName: string;
    }>;
    readonly managerResponsibilities: {
      readonly __typename?: 'ManagerResponsibilitiesFull';
      readonly stabilizationAgent?: string | null;
      readonly settlementAgent?: string | null;
      readonly logisticsAgent?: string | null;
      readonly leftLead?: string | null;
    };
  } | null;
  readonly issuer: {
    readonly __typename?: 'IssuerFull';
    readonly name: string;
    readonly sector?: Types.Sector | null;
  };
  readonly terms: {
    readonly __typename?: 'TermsFull';
    readonly maturityDate?: string | null;
    readonly filings: ReadonlyArray<{
      readonly __typename?: 'FilingFull';
      readonly id: string;
      readonly filingType: Types.FilingType;
      readonly ipoRangeLow?: number | null;
      readonly ipoRangeHigh?: number | null;
      readonly offerPrice?: number | null;
      readonly coupon?: number | null;
      readonly couponTalkHigh?: number | null;
      readonly couponTalkLow?: number | null;
      readonly premium?: number | null;
      readonly premiumTalkHigh?: number | null;
      readonly premiumTalkLow?: number | null;
    }>;
    readonly followOnPricing?: {
      readonly __typename?: 'FollowOnPricingFull';
      readonly reOfferLow?: number | null;
      readonly reOfferHigh?: number | null;
      readonly lastTradeBeforeLaunch?: number | null;
    } | null;
  };
  readonly instruments: ReadonlyArray<{
    readonly __typename?: 'InstrumentFull';
    readonly id: string;
    readonly currencyCode?: string | null;
    readonly countryCode?: string | null;
    readonly stockSymbol?: string | null;
    readonly region?: string | null;
    readonly countryDisplayName?: string | null;
  }>;
};

export type SideBar_OfferingDetails_OfferingQueryVariables = Types.Exact<{
  offeringId: Types.Scalars['UUID']['input'];
}>;

export type SideBar_OfferingDetails_OfferingQuery = {
  readonly __typename?: 'Query';
  readonly publishedOfferings?: {
    readonly __typename?: 'PublishedOfferingsCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'OfferingFull';
      readonly id: string;
      readonly type: Types.OfferingType;
      readonly status: Types.OfferingStatus;
      readonly pricingInstrumentId?: string | null;
      readonly isExecutingOnPlatform: boolean;
      readonly pricingCurrencyCode: string;
      readonly priceRangeLow?: number | null;
      readonly priceRangeHigh?: number | null;
      readonly pricingInstrumentStockSymbol?: string | null;
      readonly sizeInCurrency?: number | null;
      readonly syndicate?: {
        readonly __typename?: 'SyndicateFull';
        readonly managers: ReadonlyArray<{
          readonly __typename?: 'ManagerFull';
          readonly id: string;
          readonly cmgEntityKey: string;
          readonly role: Types.ManagerRole;
          readonly isJuniorRole?: boolean | null;
          readonly isParticipating: boolean;
          readonly firmName: string;
        }>;
        readonly managerResponsibilities: {
          readonly __typename?: 'ManagerResponsibilitiesFull';
          readonly stabilizationAgent?: string | null;
          readonly settlementAgent?: string | null;
          readonly logisticsAgent?: string | null;
          readonly leftLead?: string | null;
        };
      } | null;
      readonly issuer: {
        readonly __typename?: 'IssuerFull';
        readonly name: string;
        readonly sector?: Types.Sector | null;
      };
      readonly terms: {
        readonly __typename?: 'TermsFull';
        readonly maturityDate?: string | null;
        readonly filings: ReadonlyArray<{
          readonly __typename?: 'FilingFull';
          readonly id: string;
          readonly filingType: Types.FilingType;
          readonly ipoRangeLow?: number | null;
          readonly ipoRangeHigh?: number | null;
          readonly offerPrice?: number | null;
          readonly coupon?: number | null;
          readonly couponTalkHigh?: number | null;
          readonly couponTalkLow?: number | null;
          readonly premium?: number | null;
          readonly premiumTalkHigh?: number | null;
          readonly premiumTalkLow?: number | null;
        }>;
        readonly followOnPricing?: {
          readonly __typename?: 'FollowOnPricingFull';
          readonly reOfferLow?: number | null;
          readonly reOfferHigh?: number | null;
          readonly lastTradeBeforeLaunch?: number | null;
        } | null;
      };
      readonly instruments: ReadonlyArray<{
        readonly __typename?: 'InstrumentFull';
        readonly id: string;
        readonly currencyCode?: string | null;
        readonly countryCode?: string | null;
        readonly stockSymbol?: string | null;
        readonly region?: string | null;
        readonly countryDisplayName?: string | null;
      }>;
    }> | null;
  } | null;
};

export type SideBar_OfferingDetails_Offering_BuySide_FundPartsFragment = {
  readonly __typename?: 'Fund';
  readonly id: string;
  readonly name: string;
};

export type SideBar_OfferingDetails_Offering_BuySide_FundAllocationPartsFragment = {
  readonly __typename?: 'FundAllocation';
  readonly id: string;
  readonly fundId: string;
  readonly offeringId: string;
  readonly shares?: number | null;
  readonly fillPercentage?: number | null;
  readonly pctOfFirmAllocation?: number | null;
};

export type SideBar_OfferingDetails_Offering_BuySide_FundIoiPartsFragment = {
  readonly __typename?: 'FundIoi';
  readonly id: string;
  readonly fundId: string;
  readonly offeringId: string;
  readonly pricingType: Types.IoiPricingType;
  readonly unitType: Types.IoiUnitType;
  readonly limitPrice?: number | null;
  readonly shares?: number | null;
  readonly dollars?: number | null;
  readonly percentage?: number | null;
  readonly calculateShares?: number | null;
  readonly realDemandDollars?: number | null;
  readonly realDemandPercentage?: number | null;
  readonly realDemandShares?: number | null;
};

export type SideBar_OfferingDetails_Offering_BuySide_FundIoisPartsFragment = {
  readonly __typename?: 'FundIois';
  readonly allocations: ReadonlyArray<{
    readonly __typename?: 'FundAllocation';
    readonly id: string;
    readonly fundId: string;
    readonly offeringId: string;
    readonly shares?: number | null;
    readonly fillPercentage?: number | null;
    readonly pctOfFirmAllocation?: number | null;
  }>;
  readonly iois: ReadonlyArray<{
    readonly __typename?: 'FundIoi';
    readonly id: string;
    readonly fundId: string;
    readonly offeringId: string;
    readonly pricingType: Types.IoiPricingType;
    readonly unitType: Types.IoiUnitType;
    readonly limitPrice?: number | null;
    readonly shares?: number | null;
    readonly dollars?: number | null;
    readonly percentage?: number | null;
    readonly calculateShares?: number | null;
    readonly realDemandDollars?: number | null;
    readonly realDemandPercentage?: number | null;
    readonly realDemandShares?: number | null;
  }>;
};

export type SideBar_OfferingDetails_Offering_BuySide_DataLabFullPartsFragment = {
  readonly __typename?: 'DataLabFull';
  readonly linkedOfferingId?: string | null;
  readonly funds?: ReadonlyArray<{
    readonly __typename?: 'Fund';
    readonly id: string;
    readonly name: string;
  }> | null;
  readonly fundIois?: {
    readonly __typename?: 'FundIois';
    readonly allocations: ReadonlyArray<{
      readonly __typename?: 'FundAllocation';
      readonly id: string;
      readonly fundId: string;
      readonly offeringId: string;
      readonly shares?: number | null;
      readonly fillPercentage?: number | null;
      readonly pctOfFirmAllocation?: number | null;
    }>;
    readonly iois: ReadonlyArray<{
      readonly __typename?: 'FundIoi';
      readonly id: string;
      readonly fundId: string;
      readonly offeringId: string;
      readonly pricingType: Types.IoiPricingType;
      readonly unitType: Types.IoiUnitType;
      readonly limitPrice?: number | null;
      readonly shares?: number | null;
      readonly dollars?: number | null;
      readonly percentage?: number | null;
      readonly calculateShares?: number | null;
      readonly realDemandDollars?: number | null;
      readonly realDemandPercentage?: number | null;
      readonly realDemandShares?: number | null;
    }>;
  } | null;
};

export type SideBar_OfferingDetails_Offering_BuySidePartsFragment = {
  readonly __typename?: 'OfferingFull';
  readonly id: string;
  readonly type: Types.OfferingType;
  readonly status: Types.OfferingStatus;
  readonly pricingInstrumentId?: string | null;
  readonly isExecutingOnPlatform: boolean;
  readonly pricingCurrencyCode: string;
  readonly priceRangeLow?: number | null;
  readonly priceRangeHigh?: number | null;
  readonly pricingInstrumentStockSymbol?: string | null;
  readonly sizeInCurrency?: number | null;
  readonly dataLabFull: {
    readonly __typename?: 'DataLabFull';
    readonly linkedOfferingId?: string | null;
    readonly funds?: ReadonlyArray<{
      readonly __typename?: 'Fund';
      readonly id: string;
      readonly name: string;
    }> | null;
    readonly fundIois?: {
      readonly __typename?: 'FundIois';
      readonly allocations: ReadonlyArray<{
        readonly __typename?: 'FundAllocation';
        readonly id: string;
        readonly fundId: string;
        readonly offeringId: string;
        readonly shares?: number | null;
        readonly fillPercentage?: number | null;
        readonly pctOfFirmAllocation?: number | null;
      }>;
      readonly iois: ReadonlyArray<{
        readonly __typename?: 'FundIoi';
        readonly id: string;
        readonly fundId: string;
        readonly offeringId: string;
        readonly pricingType: Types.IoiPricingType;
        readonly unitType: Types.IoiUnitType;
        readonly limitPrice?: number | null;
        readonly shares?: number | null;
        readonly dollars?: number | null;
        readonly percentage?: number | null;
        readonly calculateShares?: number | null;
        readonly realDemandDollars?: number | null;
        readonly realDemandPercentage?: number | null;
        readonly realDemandShares?: number | null;
      }>;
    } | null;
  };
  readonly syndicate?: {
    readonly __typename?: 'SyndicateFull';
    readonly managers: ReadonlyArray<{
      readonly __typename?: 'ManagerFull';
      readonly id: string;
      readonly cmgEntityKey: string;
      readonly role: Types.ManagerRole;
      readonly isJuniorRole?: boolean | null;
      readonly isParticipating: boolean;
      readonly firmName: string;
    }>;
    readonly managerResponsibilities: {
      readonly __typename?: 'ManagerResponsibilitiesFull';
      readonly stabilizationAgent?: string | null;
      readonly settlementAgent?: string | null;
      readonly logisticsAgent?: string | null;
      readonly leftLead?: string | null;
    };
  } | null;
  readonly issuer: {
    readonly __typename?: 'IssuerFull';
    readonly name: string;
    readonly sector?: Types.Sector | null;
  };
  readonly terms: {
    readonly __typename?: 'TermsFull';
    readonly maturityDate?: string | null;
    readonly filings: ReadonlyArray<{
      readonly __typename?: 'FilingFull';
      readonly id: string;
      readonly filingType: Types.FilingType;
      readonly ipoRangeLow?: number | null;
      readonly ipoRangeHigh?: number | null;
      readonly offerPrice?: number | null;
      readonly coupon?: number | null;
      readonly couponTalkHigh?: number | null;
      readonly couponTalkLow?: number | null;
      readonly premium?: number | null;
      readonly premiumTalkHigh?: number | null;
      readonly premiumTalkLow?: number | null;
    }>;
    readonly followOnPricing?: {
      readonly __typename?: 'FollowOnPricingFull';
      readonly reOfferLow?: number | null;
      readonly reOfferHigh?: number | null;
      readonly lastTradeBeforeLaunch?: number | null;
    } | null;
  };
  readonly instruments: ReadonlyArray<{
    readonly __typename?: 'InstrumentFull';
    readonly id: string;
    readonly currencyCode?: string | null;
    readonly countryCode?: string | null;
    readonly stockSymbol?: string | null;
    readonly region?: string | null;
    readonly countryDisplayName?: string | null;
  }>;
};

export type SideBar_OfferingDetails_Offering_BuySideQueryVariables = Types.Exact<{
  offeringId: Types.Scalars['UUID']['input'];
}>;

export type SideBar_OfferingDetails_Offering_BuySideQuery = {
  readonly __typename?: 'Query';
  readonly publishedOfferings?: {
    readonly __typename?: 'PublishedOfferingsCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'OfferingFull';
      readonly id: string;
      readonly type: Types.OfferingType;
      readonly status: Types.OfferingStatus;
      readonly pricingInstrumentId?: string | null;
      readonly isExecutingOnPlatform: boolean;
      readonly pricingCurrencyCode: string;
      readonly priceRangeLow?: number | null;
      readonly priceRangeHigh?: number | null;
      readonly pricingInstrumentStockSymbol?: string | null;
      readonly sizeInCurrency?: number | null;
      readonly dataLabFull: {
        readonly __typename?: 'DataLabFull';
        readonly linkedOfferingId?: string | null;
        readonly funds?: ReadonlyArray<{
          readonly __typename?: 'Fund';
          readonly id: string;
          readonly name: string;
        }> | null;
        readonly fundIois?: {
          readonly __typename?: 'FundIois';
          readonly allocations: ReadonlyArray<{
            readonly __typename?: 'FundAllocation';
            readonly id: string;
            readonly fundId: string;
            readonly offeringId: string;
            readonly shares?: number | null;
            readonly fillPercentage?: number | null;
            readonly pctOfFirmAllocation?: number | null;
          }>;
          readonly iois: ReadonlyArray<{
            readonly __typename?: 'FundIoi';
            readonly id: string;
            readonly fundId: string;
            readonly offeringId: string;
            readonly pricingType: Types.IoiPricingType;
            readonly unitType: Types.IoiUnitType;
            readonly limitPrice?: number | null;
            readonly shares?: number | null;
            readonly dollars?: number | null;
            readonly percentage?: number | null;
            readonly calculateShares?: number | null;
            readonly realDemandDollars?: number | null;
            readonly realDemandPercentage?: number | null;
            readonly realDemandShares?: number | null;
          }>;
        } | null;
      };
      readonly syndicate?: {
        readonly __typename?: 'SyndicateFull';
        readonly managers: ReadonlyArray<{
          readonly __typename?: 'ManagerFull';
          readonly id: string;
          readonly cmgEntityKey: string;
          readonly role: Types.ManagerRole;
          readonly isJuniorRole?: boolean | null;
          readonly isParticipating: boolean;
          readonly firmName: string;
        }>;
        readonly managerResponsibilities: {
          readonly __typename?: 'ManagerResponsibilitiesFull';
          readonly stabilizationAgent?: string | null;
          readonly settlementAgent?: string | null;
          readonly logisticsAgent?: string | null;
          readonly leftLead?: string | null;
        };
      } | null;
      readonly issuer: {
        readonly __typename?: 'IssuerFull';
        readonly name: string;
        readonly sector?: Types.Sector | null;
      };
      readonly terms: {
        readonly __typename?: 'TermsFull';
        readonly maturityDate?: string | null;
        readonly filings: ReadonlyArray<{
          readonly __typename?: 'FilingFull';
          readonly id: string;
          readonly filingType: Types.FilingType;
          readonly ipoRangeLow?: number | null;
          readonly ipoRangeHigh?: number | null;
          readonly offerPrice?: number | null;
          readonly coupon?: number | null;
          readonly couponTalkHigh?: number | null;
          readonly couponTalkLow?: number | null;
          readonly premium?: number | null;
          readonly premiumTalkHigh?: number | null;
          readonly premiumTalkLow?: number | null;
        }>;
        readonly followOnPricing?: {
          readonly __typename?: 'FollowOnPricingFull';
          readonly reOfferLow?: number | null;
          readonly reOfferHigh?: number | null;
          readonly lastTradeBeforeLaunch?: number | null;
        } | null;
      };
      readonly instruments: ReadonlyArray<{
        readonly __typename?: 'InstrumentFull';
        readonly id: string;
        readonly currencyCode?: string | null;
        readonly countryCode?: string | null;
        readonly stockSymbol?: string | null;
        readonly region?: string | null;
        readonly countryDisplayName?: string | null;
      }>;
    }> | null;
  } | null;
};

export type SideBar_OfferingSellingRestrictions_OfferingPartsFragment = {
  readonly __typename?: 'OfferingFull';
  readonly id: string;
  readonly type: Types.OfferingType;
  readonly instruments: ReadonlyArray<{
    readonly __typename?: 'InstrumentFull';
    readonly id: string;
    readonly sellingRestrictions?: Types.SellingRestrictions | null;
  }>;
};

export type SideBar_OfferingSellingRestrictions_OfferingQueryVariables = Types.Exact<{
  offeringId: Types.Scalars['UUID']['input'];
}>;

export type SideBar_OfferingSellingRestrictions_OfferingQuery = {
  readonly __typename?: 'Query';
  readonly publishedOfferings?: {
    readonly __typename?: 'PublishedOfferingsCollectionSegment';
    readonly items?: ReadonlyArray<{
      readonly __typename?: 'OfferingFull';
      readonly id: string;
      readonly type: Types.OfferingType;
      readonly instruments: ReadonlyArray<{
        readonly __typename?: 'InstrumentFull';
        readonly id: string;
        readonly sellingRestrictions?: Types.SellingRestrictions | null;
      }>;
    }> | null;
  } | null;
};

export const SideBar_OfferingDetails_Offering_BuySide_FundPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySide_FundParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Fund' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const SideBar_OfferingDetails_Offering_BuySide_FundAllocationPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySide_FundAllocationParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundAllocation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fundId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offeringId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shares' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fillPercentage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pctOfFirmAllocation' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const SideBar_OfferingDetails_Offering_BuySide_FundIoiPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySide_FundIoiParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundIoi' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fundId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offeringId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unitType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limitPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shares' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dollars' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculateShares' } },
          { kind: 'Field', name: { kind: 'Name', value: 'realDemandDollars' } },
          { kind: 'Field', name: { kind: 'Name', value: 'realDemandPercentage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'realDemandShares' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const SideBar_OfferingDetails_Offering_BuySide_FundIoisPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySide_FundIoisParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundIois' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allocations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'SideBar_OfferingDetails_Offering_BuySide_FundAllocationParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'iois' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'SideBar_OfferingDetails_Offering_BuySide_FundIoiParts',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySide_FundAllocationParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundAllocation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fundId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offeringId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shares' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fillPercentage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pctOfFirmAllocation' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySide_FundIoiParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundIoi' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fundId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offeringId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unitType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limitPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shares' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dollars' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculateShares' } },
          { kind: 'Field', name: { kind: 'Name', value: 'realDemandDollars' } },
          { kind: 'Field', name: { kind: 'Name', value: 'realDemandPercentage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'realDemandShares' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const SideBar_OfferingDetails_Offering_BuySide_DataLabFullPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySide_DataLabFullParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DataLabFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'linkedOfferingId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'funds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'SideBar_OfferingDetails_Offering_BuySide_FundParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fundIois' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'SideBar_OfferingDetails_Offering_BuySide_FundIoisParts',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySide_FundParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Fund' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySide_FundAllocationParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundAllocation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fundId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offeringId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shares' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fillPercentage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pctOfFirmAllocation' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySide_FundIoiParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundIoi' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fundId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offeringId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unitType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limitPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shares' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dollars' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculateShares' } },
          { kind: 'Field', name: { kind: 'Name', value: 'realDemandDollars' } },
          { kind: 'Field', name: { kind: 'Name', value: 'realDemandPercentage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'realDemandShares' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySide_FundIoisParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundIois' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allocations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'SideBar_OfferingDetails_Offering_BuySide_FundAllocationParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'iois' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'SideBar_OfferingDetails_Offering_BuySide_FundIoiParts',
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const SideBar_OfferingDetails_Offering_BuySidePartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySideParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OfferingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'SideBar_OfferingDetails_OfferingParts' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dataLabFull' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'SideBar_OfferingDetails_Offering_BuySide_DataLabFullParts',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'SideBar_OfferingDetails_Offering_ManagerResponsibilitiesFullParts',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ManagerResponsibilitiesFull' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stabilizationAgent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'settlementAgent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'logisticsAgent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'leftLead' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_ManagerFullParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ManagerFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJuniorRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isParticipating' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_FilingFullParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FilingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filingType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipoRangeLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipoRangeHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offerPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coupon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premium' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkLow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_FollowOnPricingFullParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FollowOnPricingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reOfferLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reOfferHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeLaunch' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_OfferingParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OfferingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingInstrumentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isExecutingOnPlatform' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingCurrencyCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priceRangeLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priceRangeHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingInstrumentStockSymbol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizeInCurrency' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'syndicate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'SideBar_OfferingDetails_Offering_ManagerFullParts',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managerResponsibilities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value:
                            'SideBar_OfferingDetails_Offering_ManagerResponsibilitiesFullParts',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sector' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'terms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maturityDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'filings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'SideBar_OfferingDetails_Offering_FilingFullParts',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'followOnPricing' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'SideBar_OfferingDetails_Offering_FollowOnPricingFullParts',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instruments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stockSymbol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryDisplayName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySide_FundParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Fund' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySide_FundAllocationParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundAllocation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fundId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offeringId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shares' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fillPercentage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pctOfFirmAllocation' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySide_FundIoiParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundIoi' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fundId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offeringId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unitType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limitPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shares' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dollars' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculateShares' } },
          { kind: 'Field', name: { kind: 'Name', value: 'realDemandDollars' } },
          { kind: 'Field', name: { kind: 'Name', value: 'realDemandPercentage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'realDemandShares' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySide_FundIoisParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundIois' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allocations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'SideBar_OfferingDetails_Offering_BuySide_FundAllocationParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'iois' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'SideBar_OfferingDetails_Offering_BuySide_FundIoiParts',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySide_DataLabFullParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DataLabFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'linkedOfferingId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'funds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'SideBar_OfferingDetails_Offering_BuySide_FundParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fundIois' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'SideBar_OfferingDetails_Offering_BuySide_FundIoisParts',
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const SideBar_OfferingSellingRestrictions_OfferingPartsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingSellingRestrictions_OfferingParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OfferingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instruments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sellingRestrictions' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const SideBar_OfferingDetails_OfferingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offeringId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishedOfferings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'offeringId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'SideBar_OfferingDetails_OfferingParts' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'SideBar_OfferingDetails_Offering_ManagerResponsibilitiesFullParts',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ManagerResponsibilitiesFull' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stabilizationAgent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'settlementAgent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'logisticsAgent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'leftLead' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_ManagerFullParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ManagerFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJuniorRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isParticipating' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_FilingFullParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FilingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filingType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipoRangeLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipoRangeHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offerPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coupon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premium' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkLow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_FollowOnPricingFullParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FollowOnPricingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reOfferLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reOfferHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeLaunch' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_OfferingParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OfferingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingInstrumentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isExecutingOnPlatform' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingCurrencyCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priceRangeLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priceRangeHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingInstrumentStockSymbol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizeInCurrency' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'syndicate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'SideBar_OfferingDetails_Offering_ManagerFullParts',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managerResponsibilities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value:
                            'SideBar_OfferingDetails_Offering_ManagerResponsibilitiesFullParts',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sector' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'terms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maturityDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'filings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'SideBar_OfferingDetails_Offering_FilingFullParts',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'followOnPricing' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'SideBar_OfferingDetails_Offering_FollowOnPricingFullParts',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instruments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stockSymbol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryDisplayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSideBar_OfferingDetails_OfferingQuery__
 *
 * To run a query within a React component, call `useSideBar_OfferingDetails_OfferingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSideBar_OfferingDetails_OfferingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSideBar_OfferingDetails_OfferingQuery({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *   },
 * });
 */
export function useSideBar_OfferingDetails_OfferingQuery(
  baseOptions: Apollo.QueryHookOptions<
    SideBar_OfferingDetails_OfferingQuery,
    SideBar_OfferingDetails_OfferingQueryVariables
  > &
    (
      | { variables: SideBar_OfferingDetails_OfferingQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SideBar_OfferingDetails_OfferingQuery,
    SideBar_OfferingDetails_OfferingQueryVariables
  >(SideBar_OfferingDetails_OfferingDocument, options);
}
export function useSideBar_OfferingDetails_OfferingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SideBar_OfferingDetails_OfferingQuery,
    SideBar_OfferingDetails_OfferingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SideBar_OfferingDetails_OfferingQuery,
    SideBar_OfferingDetails_OfferingQueryVariables
  >(SideBar_OfferingDetails_OfferingDocument, options);
}
// @ts-ignore
export function useSideBar_OfferingDetails_OfferingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SideBar_OfferingDetails_OfferingQuery,
    SideBar_OfferingDetails_OfferingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  SideBar_OfferingDetails_OfferingQuery,
  SideBar_OfferingDetails_OfferingQueryVariables
>;
export function useSideBar_OfferingDetails_OfferingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SideBar_OfferingDetails_OfferingQuery,
        SideBar_OfferingDetails_OfferingQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  SideBar_OfferingDetails_OfferingQuery | undefined,
  SideBar_OfferingDetails_OfferingQueryVariables
>;
export function useSideBar_OfferingDetails_OfferingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SideBar_OfferingDetails_OfferingQuery,
        SideBar_OfferingDetails_OfferingQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SideBar_OfferingDetails_OfferingQuery,
    SideBar_OfferingDetails_OfferingQueryVariables
  >(SideBar_OfferingDetails_OfferingDocument, options);
}
export type SideBar_OfferingDetails_OfferingQueryHookResult = ReturnType<
  typeof useSideBar_OfferingDetails_OfferingQuery
>;
export type SideBar_OfferingDetails_OfferingLazyQueryHookResult = ReturnType<
  typeof useSideBar_OfferingDetails_OfferingLazyQuery
>;
export type SideBar_OfferingDetails_OfferingSuspenseQueryHookResult = ReturnType<
  typeof useSideBar_OfferingDetails_OfferingSuspenseQuery
>;
export type SideBar_OfferingDetails_OfferingQueryResult = Apollo.QueryResult<
  SideBar_OfferingDetails_OfferingQuery,
  SideBar_OfferingDetails_OfferingQueryVariables
>;
export const SideBar_OfferingDetails_Offering_BuySideDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySide' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offeringId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishedOfferings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'offeringId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'SideBar_OfferingDetails_Offering_BuySideParts',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'SideBar_OfferingDetails_Offering_ManagerResponsibilitiesFullParts',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ManagerResponsibilitiesFull' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stabilizationAgent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'settlementAgent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'logisticsAgent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'leftLead' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_ManagerFullParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ManagerFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cmgEntityKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'role' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isJuniorRole' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isParticipating' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firmName' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_FilingFullParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FilingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filingType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipoRangeLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ipoRangeHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offerPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'coupon' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'couponTalkLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premium' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'premiumTalkLow' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_FollowOnPricingFullParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FollowOnPricingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reOfferLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reOfferHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastTradeBeforeLaunch' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_OfferingParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OfferingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingInstrumentId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isExecutingOnPlatform' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingCurrencyCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priceRangeLow' } },
          { kind: 'Field', name: { kind: 'Name', value: 'priceRangeHigh' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingInstrumentStockSymbol' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sizeInCurrency' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'syndicate' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'SideBar_OfferingDetails_Offering_ManagerFullParts',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managerResponsibilities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value:
                            'SideBar_OfferingDetails_Offering_ManagerResponsibilitiesFullParts',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sector' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'terms' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'maturityDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'filings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'SideBar_OfferingDetails_Offering_FilingFullParts',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'followOnPricing' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'SideBar_OfferingDetails_Offering_FollowOnPricingFullParts',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instruments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stockSymbol' } },
                { kind: 'Field', name: { kind: 'Name', value: 'region' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryDisplayName' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySide_FundParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Fund' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySide_FundAllocationParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundAllocation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fundId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offeringId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shares' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fillPercentage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pctOfFirmAllocation' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySide_FundIoiParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundIoi' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fundId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'offeringId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pricingType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'unitType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'limitPrice' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shares' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dollars' } },
          { kind: 'Field', name: { kind: 'Name', value: 'percentage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'calculateShares' } },
          { kind: 'Field', name: { kind: 'Name', value: 'realDemandDollars' } },
          { kind: 'Field', name: { kind: 'Name', value: 'realDemandPercentage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'realDemandShares' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySide_FundIoisParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FundIois' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allocations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'SideBar_OfferingDetails_Offering_BuySide_FundAllocationParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'iois' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'SideBar_OfferingDetails_Offering_BuySide_FundIoiParts',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySide_DataLabFullParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DataLabFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'linkedOfferingId' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'funds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'SideBar_OfferingDetails_Offering_BuySide_FundParts',
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fundIois' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'SideBar_OfferingDetails_Offering_BuySide_FundIoisParts',
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingDetails_Offering_BuySideParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OfferingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'SideBar_OfferingDetails_OfferingParts' },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dataLabFull' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'SideBar_OfferingDetails_Offering_BuySide_DataLabFullParts',
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSideBar_OfferingDetails_Offering_BuySideQuery__
 *
 * To run a query within a React component, call `useSideBar_OfferingDetails_Offering_BuySideQuery` and pass it any options that fit your needs.
 * When your component renders, `useSideBar_OfferingDetails_Offering_BuySideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSideBar_OfferingDetails_Offering_BuySideQuery({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *   },
 * });
 */
export function useSideBar_OfferingDetails_Offering_BuySideQuery(
  baseOptions: Apollo.QueryHookOptions<
    SideBar_OfferingDetails_Offering_BuySideQuery,
    SideBar_OfferingDetails_Offering_BuySideQueryVariables
  > &
    (
      | { variables: SideBar_OfferingDetails_Offering_BuySideQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SideBar_OfferingDetails_Offering_BuySideQuery,
    SideBar_OfferingDetails_Offering_BuySideQueryVariables
  >(SideBar_OfferingDetails_Offering_BuySideDocument, options);
}
export function useSideBar_OfferingDetails_Offering_BuySideLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SideBar_OfferingDetails_Offering_BuySideQuery,
    SideBar_OfferingDetails_Offering_BuySideQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SideBar_OfferingDetails_Offering_BuySideQuery,
    SideBar_OfferingDetails_Offering_BuySideQueryVariables
  >(SideBar_OfferingDetails_Offering_BuySideDocument, options);
}
// @ts-ignore
export function useSideBar_OfferingDetails_Offering_BuySideSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SideBar_OfferingDetails_Offering_BuySideQuery,
    SideBar_OfferingDetails_Offering_BuySideQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  SideBar_OfferingDetails_Offering_BuySideQuery,
  SideBar_OfferingDetails_Offering_BuySideQueryVariables
>;
export function useSideBar_OfferingDetails_Offering_BuySideSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SideBar_OfferingDetails_Offering_BuySideQuery,
        SideBar_OfferingDetails_Offering_BuySideQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  SideBar_OfferingDetails_Offering_BuySideQuery | undefined,
  SideBar_OfferingDetails_Offering_BuySideQueryVariables
>;
export function useSideBar_OfferingDetails_Offering_BuySideSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SideBar_OfferingDetails_Offering_BuySideQuery,
        SideBar_OfferingDetails_Offering_BuySideQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SideBar_OfferingDetails_Offering_BuySideQuery,
    SideBar_OfferingDetails_Offering_BuySideQueryVariables
  >(SideBar_OfferingDetails_Offering_BuySideDocument, options);
}
export type SideBar_OfferingDetails_Offering_BuySideQueryHookResult = ReturnType<
  typeof useSideBar_OfferingDetails_Offering_BuySideQuery
>;
export type SideBar_OfferingDetails_Offering_BuySideLazyQueryHookResult = ReturnType<
  typeof useSideBar_OfferingDetails_Offering_BuySideLazyQuery
>;
export type SideBar_OfferingDetails_Offering_BuySideSuspenseQueryHookResult = ReturnType<
  typeof useSideBar_OfferingDetails_Offering_BuySideSuspenseQuery
>;
export type SideBar_OfferingDetails_Offering_BuySideQueryResult = Apollo.QueryResult<
  SideBar_OfferingDetails_Offering_BuySideQuery,
  SideBar_OfferingDetails_Offering_BuySideQueryVariables
>;
export const SideBar_OfferingSellingRestrictions_OfferingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SideBar_OfferingSellingRestrictions_Offering' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offeringId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UUID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'publishedOfferings' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: {
                              kind: 'Variable',
                              name: { kind: 'Name', value: 'offeringId' },
                            },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'SideBar_OfferingSellingRestrictions_OfferingParts',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SideBar_OfferingSellingRestrictions_OfferingParts' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'OfferingFull' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'instruments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sellingRestrictions' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useSideBar_OfferingSellingRestrictions_OfferingQuery__
 *
 * To run a query within a React component, call `useSideBar_OfferingSellingRestrictions_OfferingQuery` and pass it any options that fit your needs.
 * When your component renders, `useSideBar_OfferingSellingRestrictions_OfferingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSideBar_OfferingSellingRestrictions_OfferingQuery({
 *   variables: {
 *      offeringId: // value for 'offeringId'
 *   },
 * });
 */
export function useSideBar_OfferingSellingRestrictions_OfferingQuery(
  baseOptions: Apollo.QueryHookOptions<
    SideBar_OfferingSellingRestrictions_OfferingQuery,
    SideBar_OfferingSellingRestrictions_OfferingQueryVariables
  > &
    (
      | { variables: SideBar_OfferingSellingRestrictions_OfferingQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SideBar_OfferingSellingRestrictions_OfferingQuery,
    SideBar_OfferingSellingRestrictions_OfferingQueryVariables
  >(SideBar_OfferingSellingRestrictions_OfferingDocument, options);
}
export function useSideBar_OfferingSellingRestrictions_OfferingLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SideBar_OfferingSellingRestrictions_OfferingQuery,
    SideBar_OfferingSellingRestrictions_OfferingQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SideBar_OfferingSellingRestrictions_OfferingQuery,
    SideBar_OfferingSellingRestrictions_OfferingQueryVariables
  >(SideBar_OfferingSellingRestrictions_OfferingDocument, options);
}
// @ts-ignore
export function useSideBar_OfferingSellingRestrictions_OfferingSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SideBar_OfferingSellingRestrictions_OfferingQuery,
    SideBar_OfferingSellingRestrictions_OfferingQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  SideBar_OfferingSellingRestrictions_OfferingQuery,
  SideBar_OfferingSellingRestrictions_OfferingQueryVariables
>;
export function useSideBar_OfferingSellingRestrictions_OfferingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SideBar_OfferingSellingRestrictions_OfferingQuery,
        SideBar_OfferingSellingRestrictions_OfferingQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  SideBar_OfferingSellingRestrictions_OfferingQuery | undefined,
  SideBar_OfferingSellingRestrictions_OfferingQueryVariables
>;
export function useSideBar_OfferingSellingRestrictions_OfferingSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SideBar_OfferingSellingRestrictions_OfferingQuery,
        SideBar_OfferingSellingRestrictions_OfferingQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SideBar_OfferingSellingRestrictions_OfferingQuery,
    SideBar_OfferingSellingRestrictions_OfferingQueryVariables
  >(SideBar_OfferingSellingRestrictions_OfferingDocument, options);
}
export type SideBar_OfferingSellingRestrictions_OfferingQueryHookResult = ReturnType<
  typeof useSideBar_OfferingSellingRestrictions_OfferingQuery
>;
export type SideBar_OfferingSellingRestrictions_OfferingLazyQueryHookResult = ReturnType<
  typeof useSideBar_OfferingSellingRestrictions_OfferingLazyQuery
>;
export type SideBar_OfferingSellingRestrictions_OfferingSuspenseQueryHookResult = ReturnType<
  typeof useSideBar_OfferingSellingRestrictions_OfferingSuspenseQuery
>;
export type SideBar_OfferingSellingRestrictions_OfferingQueryResult = Apollo.QueryResult<
  SideBar_OfferingSellingRestrictions_OfferingQuery,
  SideBar_OfferingSellingRestrictions_OfferingQueryVariables
>;

import { makeMockResponse } from '../../../../../../graphql/mock-response';

export const makeSideBar_OfferingDetails_OfferingMockResponse = makeMockResponse<
  SideBar_OfferingDetails_OfferingQueryVariables,
  SideBar_OfferingDetails_OfferingQuery
>(SideBar_OfferingDetails_OfferingDocument);

export const makeSideBar_OfferingDetails_Offering_BuySideMockResponse = makeMockResponse<
  SideBar_OfferingDetails_Offering_BuySideQueryVariables,
  SideBar_OfferingDetails_Offering_BuySideQuery
>(SideBar_OfferingDetails_Offering_BuySideDocument);

export const makeSideBar_OfferingSellingRestrictions_OfferingMockResponse = makeMockResponse<
  SideBar_OfferingSellingRestrictions_OfferingQueryVariables,
  SideBar_OfferingSellingRestrictions_OfferingQuery
>(SideBar_OfferingSellingRestrictions_OfferingDocument);
